import React from 'react';
import CheckboxInput from "./CheckboxInput";

const CheckboxInputValueCompatible = (props) => {

    const handleChange = (e) => {
        let checked = e.target.checked;
        props.onChange(props.name, (e.target.checked) ? true : false)
    }

    return (
        <CheckboxInput
            name={props.name}
            checked={props.value === true}
            onChange={handleChange}
            color={props.color}
        />
    )
}

export default CheckboxInputValueCompatible;

